import Grid from "@mui/material/Grid2"; // Using Grid2 as specified in the original import
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import Paper from "@mui/material/Paper";
import {
  Divider,
  Select,
  MenuItem,
  TextField,
  FormControl,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";

const DataEmisor = (datos) => {
  const {
    configuracion,
    handleChange,
    validation,
    toggleDepModal,
    toggleDisModal,
    toggleCiuModal,
  } = datos;

  return (
    <form>
      {/* Main form Grid adapted to match the Box's column system */}
      <Grid
        container
        id="form"
        spacing={2}
        // columns={{ xs: 4, sm: 8, md: 12 }}
        // sx={{ mt: 2 }}
      >
        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <TextField
                fullWidth
                label="R.U.C."
                name="rucemi"
                value={configuracion.rucemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.rucemi}
                helperText={validation.rucemi}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 2 }}>
              <TextField
                fullWidth
                label="D.V."
                name="dvemi"
                inputProps={{ maxLength: 1 }}
                value={configuracion.dvemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.dvemi}
                helperText={validation.dvemi}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <FormControl fullWidth>
                <InputLabel id="tipcontrib-label">
                  Tipo de Contribuyente
                </InputLabel>
                <Select
                  labelId="tipcontrib-label"
                  id="tipcontrib"
                  name="tipcontrib"
                  value={configuracion.tipcontrib}
                  label="Tipo de Contribuyente"
                  onChange={handleChange}
                  onBlur={handleChange}
                >
                  <MenuItem value="1">Persona Física</MenuItem>
                  <MenuItem value="2">Persona Jurídica</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <TextField
                fullWidth
                label="Nombre / Razón Social"
                name="nomemi"
                value={configuracion.nomemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.nomemi}
                helperText={validation.nomemi}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <TextField
                fullWidth
                label="Nombre de Fantasía"
                name="nomfanemi"
                value={configuracion.nomfanemi}
                onChange={handleChange}
                onBlur={handleChange}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <TextField
                fullWidth
                label="Dirección "
                name="diremi"
                value={configuracion.diremi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.diremi}
                helperText={validation.diremi}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2} sx={{ mb: 2 }}>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <TextField
                fullWidth
                label="Número de casa"
                name="numcas"
                value={configuracion.numcas}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.numcas}
                helperText={validation.numcas}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <TextField
                fullWidth
                label="Teléfono"
                name="telemi"
                value={configuracion.telemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.telemi}
                helperText={validation.telemi}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <TextField
                fullWidth
                label="Email"
                name="mailemi"
                value={configuracion.mailemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.mailemi}
                helperText={validation.mailemi}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2}>
            <Grid size={{ xs: 3, sm: 2, md: 1 }}>
              <TextField
                fullWidth
                label="Código"
                name="depemi"
                value={configuracion.depemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.depemi}
                helperText={validation.depemi}
              />
            </Grid>
            <Grid size={{ xs: 7, sm: 8, md: 4 }}>
              <TextField
                fullWidth
                label="Departamento"
                name="depemidesc"
                disabled
                value={configuracion.depemidesc}
                onChange={handleChange}
                onBlur={handleChange}
              />
            </Grid>
            <Grid size={{ xs: 2, sm: 2, md: 1 }}>
              <IconButton color="primary" onClick={toggleDepModal}>
                <SearchIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2}>
            <Grid size={{ xs: 3, sm: 2, md: 1 }}>
              <TextField
                fullWidth
                label="Código"
                name="disemi"
                value={configuracion.disemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.disemi}
                helperText={validation.disemi}
              />
            </Grid>
            <Grid size={{ xs: 7, sm: 8, md: 4 }}>
              <TextField
                fullWidth
                label="Distrito"
                name="disemidesc"
                disabled
                value={configuracion.disemidesc}
                onChange={handleChange}
                onBlur={handleChange}
              />
            </Grid>
            <Grid size={{ xs: 2, sm: 2, md: 1 }}>
              <IconButton color="primary" onClick={toggleDisModal}>
                <SearchIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>

        <Grid size={12}>
          <Grid container alignItems="flex-end" spacing={2}>
            <Grid size={{ xs: 3, sm: 2, md: 1 }}>
              <TextField
                fullWidth
                label="Código"
                name="ciuemi"
                value={configuracion.ciuemi}
                onChange={handleChange}
                onBlur={handleChange}
                error={!!validation.ciuemi}
                helperText={validation.ciuemi}
              />
            </Grid>
            <Grid size={{ xs: 7, sm: 8, md: 4 }}>
              <TextField
                fullWidth
                label="Ciudad"
                name="ciuemidesc"
                disabled
                value={configuracion.ciuemidesc}
                onChange={handleChange}
                onBlur={handleChange}
              />
            </Grid>
            <Grid size={{ xs: 2, sm: 2, md: 1 }}>
              <IconButton color="primary" onClick={toggleCiuModal}>
                <SearchIcon />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default DataEmisor;
